import React from "react";
import "swagger-ui-react/swagger-ui.css";
import SwaggerUI from "swagger-ui-react";
import { useGlobalState } from "Context";
import { buildEndpoint, buildRoute } from "Utilities";
import { ENDPOINTS } from "Models/Templates/Routes/Routes";

export const ExternalApiSwagger: React.FC = () => {
  const url =
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_API_SWAGGER_LINK}`
      : `${window.API_SWAGGER_LINK}`;

  return (
    <SwaggerUI
      url={url + buildEndpoint(ENDPOINTS.swaggerv1.base, "swagger.json")}
    />
  );
};
